import React from 'react';
import { Footer, Header } from '@components';

import '@styles/main.scss';
import { PropsWithLocation } from '@model';

interface LayoutProps extends PropsWithLocation {
  children: JSX.Element | JSX.Element[];
  classNames?: string;
}

export function Layout(props: LayoutProps) {
  const { children, classNames, location } = props;

  return (
    <div className={classNames}>
      <Header />
      <main>{children}</main>
      <Footer location={location} />
    </div>
  );
}
